export function isLaborCompanyOrg(orgType) {
  return orgType === 'laborCom' || orgType === '劳务分包'
}

export function isBuilderPersonOfCurrentOrg(item, orgType, orgValue) {
  if (!item) return false
  // 劳务公司级列表已按本单位过滤，本页人员均视为当前劳务公司人员
  if (isLaborCompanyOrg(orgType)) return true
  if (!orgValue) return false
  const current = String(orgValue)
  if (orgType === 'simPro') {
    return (
      String(item.orgUid || '') === current ||
      String(item.vProjectUid || item.vprojectuid || '') === current ||
      String(item.projectUid || item.projectuid || '') === current
    )
  }
  return false
}

function getCurrentOrganization(params) {
  if (!params) return {}
  const orgValue = params.orgValue || ''
  let organization = {}
  if (params.getters) {
    organization =
      params.getters['user/organization'] || params.getters.organization || {}
  }
  if (!organization.orgUid && params.state && params.state.user) {
    const orgs = params.state.user.organizations || []
    organization = orgs.find((item) => item.orgUid === orgValue) || organization
  }
  return organization
}

function leafOrgName(text) {
  const value = String(text || '')
    .replace(/\(退场\)|（退场）/g, '')
    .trim()
  if (!value) return ''
  const parts = value.split('/').map((item) => item.trim()).filter(Boolean)
  return parts.length ? parts[parts.length - 1] : value
}

export function getLaborParentBidOrg(params) {
  const organization = getCurrentOrganization(params)
  const upList = organization.upOrg || []
  return (
    upList.find(
      (org) =>
        org.professionalNature === '管控' &&
        org.professionalType === '直属标段'
    ) ||
    upList.find((org) => org.professionalType === '直属标段') ||
    null
  )
}

export function getLaborParentBidUid(params) {
  const organization = getCurrentOrganization(params)
  const bid = getLaborParentBidOrg(params)
  return (
    (bid && (bid.orgUid || bid.uid)) ||
    organization.projectUid ||
    organization.upbidSectionUid ||
    organization.parentUid ||
    organization.upVproUid ||
    ''
  )
}

export function getLaborParentBidName(params) {
  const bid = getLaborParentBidOrg(params)
  if (bid) {
    return leafOrgName(bid.orgCode || bid.orgName || bid.label)
  }
  return ''
}

/** 劳务公司本级名称，不含上级项目标段路径 */
export function getLaborCompanyName(params) {
  const organization = getCurrentOrganization(params)
  return leafOrgName(
    organization.orgName ||
      organization.vname ||
      organization.orgCode ||
      (params && params.orgName)
  )
}

function walkPages(nodes, matcher) {
  if (!nodes) return false
  const list = Array.isArray(nodes) ? nodes : [nodes]
  return list.some((item) => {
    if (!item) return false
    if (matcher(item)) return true
    return walkPages(item.children, matcher)
  })
}

function isNamedPage(item, pageName) {
  if (!item || !pageName) return false
  if (item.name === pageName) return true
  const path = String(item.path || '')
  return (
    path === '/' + pageName ||
    path === '/workbench/' + pageName ||
    path.endsWith('/' + pageName)
  )
}

export function hasWorkbenchPage(params, pageName) {
  if (!params || !pageName) return false
  const getters = params.getters || {}
  const state = params.state || {}
  const user = state.user || {}
  const orgPages =
    (user.userPages || []).find((item) => item && item.orgUid === params.orgValue) ||
    {}
  return (
    walkPages(getters['user/pages'], (item) => isNamedPage(item, pageName)) ||
    walkPages(getters['user/workbenchApp'], (item) => isNamedPage(item, pageName)) ||
    walkPages(orgPages.pages, (item) => isNamedPage(item, pageName))
  )
}

export function hasBuilderModule(params) {
  return hasWorkbenchPage(params, 'builder')
}

export function isBidQueryField(field) {
  if (!field) return false
  const label = String(field.label || '')
  const key = String(field.key || '')
  if (
    label.indexOf('项目标段') >= 0 ||
    label.indexOf('项目/标段') >= 0
  ) {
    return true
  }
  return (
    key === 'vProjectUid' ||
    key === 'upVproUid' ||
    key === 'vprojectUid'
  )
}

export function findLaborCompanyQueryField(fields) {
  if (!Array.isArray(fields)) return null
  return (
    fields.find((item) => {
      return String((item && item.label) || '').indexOf('劳务公司') >= 0
    }) || null
  )
}

export function findTeamQueryField(fields) {
  if (!Array.isArray(fields)) return null
  return (
    fields.find((item) => {
      const label = String((item && item.label) || '')
      return label.indexOf('班组') >= 0 && label.indexOf('劳务') < 0
    }) || null
  )
}

export function isEnterpriseViewOrg(orgType) {
  return orgType === 'com' || orgType === 'bigPro'
}

export const TZ_INSPECTION_ORG_NAME = '甘肃省特种设备检验检测研究院'

export function isTzOrgName(text) {
  return String(text || '').trim() === TZ_INSPECTION_ORG_NAME
}

export function isTzInspectionOrg(params) {
  if (!params) return false
  const org = getCurrentOrganization(params)
  return [
    params.orgName,
    params.orgCode,
    org.orgName,
    org.orgCode,
    org.vname
  ].some((item) => isTzOrgName(item))
}

export function isTzInspectionSession(rootGetters) {
  const org = (rootGetters && rootGetters['user/organization']) || {}
  return (
    isTzOrgName(rootGetters && rootGetters['user/orgName']) ||
    isTzOrgName(org.orgName) ||
    isTzOrgName(org.orgCode)
  )
}

export function isOfficialCarEnterpriseDirect(state) {
  if (!state) return true
  const tab = state.currentTab || {}
  const step = (state.currentStep && state.currentStep.step) || ''
  const key =
    step.indexOf('fixedEquipment') === 0 ||
    tab.label === '固定机械' ||
    tab.label === '固定设备'
      ? 'fixedEquipment'
      : 'officialCar'
  const q = (state.queryValues && state.queryValues[key]) || {}
  if (q.vprojectUid == null || q.vprojectUid === '') return true
  return isEnterpriseDirectValue(q.vprojectUid)
}

export const ENTERPRISE_DIRECT_VALUE = 'enterpriseDirect'

export function isEnterpriseDirectValue(value) {
  return (
    value === ENTERPRISE_DIRECT_VALUE ||
    value === '企业直管或租赁'
  )
}

export function withEnterpriseDirectBidOption(options, orgType) {
  const bids = Array.isArray(options) ? options.slice() : []
  if (!isEnterpriseViewOrg(orgType)) return bids
  if (
    bids.some(
      (item) =>
        item &&
        (item.value === ENTERPRISE_DIRECT_VALUE ||
          item.label === '企业直管或租赁')
    )
  ) {
    return bids
  }
  return [
    {
      label: '企业直管或租赁',
      value: ENTERPRISE_DIRECT_VALUE,
      orgUid: ENTERPRISE_DIRECT_VALUE
    }
  ].concat(bids)
}

export function applyProjectDeviceTitle(item, orgType) {
  if (!item || item.name !== 'officialCar' || !isEnterpriseViewOrg(orgType)) {
    return item
  }
  const meta = Object.assign({}, item.meta || {}, {
    title: '项目设备'
  })
  return Object.assign({}, item, {
    pageName: '项目设备',
    meta
  })
}

